import { faMapPin, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, useCallback, useState } from 'react';
import PlayerSearch from 'src/components/0400_player_search';
import { TTransactionEntity } from '../LineItem';
import useAttendance from '../hooks/useAttendance';

interface IProps extends TTransactionEntity {
  onEntityChange?: (x: TTransactionEntity) => void;
}

const TransactionEntity: FC<IProps> = ({
  characterId,
  characterName,
  playerId,
  playerName,
  onEntityChange,
}) => {
  const [showCharacterSelector, setShowCharacterSelector] = useState(false);
  const { isAttending } = useAttendance();
  const attendanceMarker = useCallback(
    ({ characterId = 0 }) => {
      if (isAttending({ characterId })) {
        return <FontAwesomeIcon icon={faMapPin} className="fa-fw -mr-1.5" />;
      }

      return <FontAwesomeIcon icon={faTimes} className="fa-fw -mr-1.5" />;
    },
    [isAttending],
  );

  return (
    <div>
      {characterId && (
        <div className="text-sm">
          Recipient: #{playerId} {playerName}: {characterName}
        </div>
      )}
      {!showCharacterSelector && (
        <div className="flex items-center gap-2">
          <button
            type="button"
            className="underline text-sm text-juno-gray-200"
            onClick={() => setShowCharacterSelector(true)}
          >
            Different Recipient?
          </button>
          {characterId && (
            <button
              type="button"
              className="underline text-sm text-juno-gray-200"
              onClick={() => {
                onEntityChange?.({
                  characterId: null,
                  characterName: null,
                  playerId: null,
                  playerName: null,
                });
              }}
            >
              Use Current Crafter?
            </button>
          )}
        </div>
      )}
      {showCharacterSelector && (
        <PlayerSearch
          withCharacters
          characterIcon={attendanceMarker}
          placeholder="Search for Recipient..."
          onSearchResultClick={({
            characterId,
            characterName,
            playerId,
            playerName,
          }) => {
            if (characterId) {
              onEntityChange?.({
                characterId,
                characterName,
                playerId,
                playerName,
              });
            }
            setShowCharacterSelector(false);
          }}
        />
      )}
    </div>
  );
};

export default TransactionEntity;
